import { compareGreater } from '@dte/otw-utils-core/src/objects/compare/compareGreater';
import type { MessageDetail } from '../../interfaces/api/messageDetail/MessageDetail';

export function getMessageDetailsByPriority<T extends MessageDetail>(map: Record<string, T>): T[] {
	let values = Object.values(map);

	// Filter to those that have priority
	values = values.filter((value) => value?.priority !== undefined);

	// Filter out any that are currently disabled
	values = values.filter((value) => !value.disabled);

	// Sort highest priority first
	values = values.sort((a, b) => compareGreater(a.priority, b.priority));

	return values;
}
